<template>
	<div class="login-back">
		<div class="login-wrapper">
			<div class="login-title">
				<AnimationGraph></AnimationGraph>
			</div>
			<div class="login-container">
				<LoginForm @login-success="handleLoginSuccess" @login-error="handleLoginError" />
			</div>
		</div>
	</div>
</template>

  
<script>
import LoginForm from '@/components/LoginForm.vue'
import Cookies from 'js-cookie' // 导入 js-cookie
import AnimationGraph from '@/graphs/AnimationGraph.vue'
import '@/styles/LoginView.css'

export default {
	components: {
		LoginForm,
		AnimationGraph
	},
	mounted() {
	},
	methods: {
		handleLoginSuccess(response) {
			console.log('Login Success:', response);
			// 保存 token 到 cookie，并设置过期时间为 1 天
			Cookies.set('token', response.token, { expires: 1 });

			// 保存 user type 到 cookie
			Cookies.set('usertype', response.type, { expires: 1 });

			// 根据 response.data.type 的值决定导航到哪个页面
			switch (response.type) {
				case 0:
					console.log("User type:", response.type);
					this.$router.push({ name: 'adminpanel' });
					break;
				case 1:
					console.log("User type:", response.type);
					this.$router.push({ name: 'userpanel' });
					break;
				default:
					console.error("Unknown user type: ", response.data.type);
					break;
			}
		},
		handleLoginError(error) {
			// 处理登陆失败的逻辑，比如显示错误消息等
			console.error('Login Error:', error);
		}
	}
};
</script>

